import o from "./isArray.js";
import i from "./_isKey.js";
import m from "./_stringToPath.js";
import f from "./toString.js";
function c(r, t) {
  return o(r) ? r : i(r, t) ? [r] : m(f(r));
}
export {
  c as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_castPath.js
// module id = 908
// module chunks = 67